import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";

import { UserTableService } from 'src/service/user.service';

import { CustomerService, DataService, FireForesightService, SiteTypeService } from 'src/api/services';
import { User,Customer, CustomerSummary, StatusType, Status, Incident, Widget, Note, SiteTwin, Statistics, ResponsibleParty, FalsePositiveType } from 'src/api/models';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ToastrService } from 'ngx-toastr';
import { CommandService } from 'src/api/services/command.service';
import { Command } from 'src/api/models/command';
import { CommandParameter } from 'src/api/models/command-parameter';
import { ActivatedRoute } from '@angular/router';
import { IMultiSourceMultiValueWidget, TimeSeriesDetail } from 'src/app/models/dashboard';
import { AbstractDataService } from 'src/service/data.service';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { FireService } from 'src/service/fire.service';
import { MapComponent } from 'src/app/components/map/map.component';
import { SmartImageDetail } from 'src/app/components/smart-image-list/smart-image-list.component';
import { ModalDirective } from 'ngx-bootstrap/modal';

// todo: fix styles
// todo: install license

@Component({
  selector: 'app-fire-foresight-incidents-watch',
  templateUrl: './fire-foresight-incidents-watch.component.html',
  styleUrls: ['./fire-foresight-incidents-watch.component.css']
})
export class FireForesightIncidentsWatchComponent implements OnInit, OnDestroy {
  @ViewChild('falsePositiveModal', { static: false }) falsePositiveModal: ModalDirective;

  public responsibleParties: ResponsibleParty[];
  public falsePositiveTypes: FalsePositiveType[];

  public list : StatusType[];
  public status : StatusType;
  @Input() public statusId: number;
  
  public incidents: Incident[];
  public incident: Incident;
  //public incident: Incident;
  //public liveWidget: IMultiSourceMultiValueWidget;
  public latestImageUrl: string;
  public selectedNote: Note;
  public newNote: string;
  public stats: Statistics;

  constructor(
    public app: ApplicationConfigService, 
    public security: AzureAuthService,
    private svc: FireForesightService, 
    public fire: FireService,
    private siteTypeService: SiteTypeService,
    private dataService: DataService,
    private toasterService: ToastrService,
    private route: ActivatedRoute) { 
    // console.log("fire-foresight-admin constructor")
  }

  
  timer: any;
  ngOnInit(): void {    
    this.route.params.subscribe(params => {
      this.statusId = params["statusId"];
    });
    this.svc.FireForesightGetStatusTypes().subscribe(r => {
      this.list = r;
      this.status = this.list.find(s => s.statusId == this.statusId);
    });
    this.svc.FireForesightGetFalsePositiveTypes().subscribe(r => {
      this.falsePositiveTypes = r;
    });
    
    this.fire.getIncidentByStatus(this.statusId).then(() => {
      if (this.timer == null){
        this.timer = setInterval(() => this.fire.getIncidentByStatus(this.statusId), 30000);
      }
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);  
  }

  loadIncident(){
    if (this.fire.incident){
      this.fire.getCamera(this.fire.incident.site.siteId, false, c => {
        // this.map is not loaded - why???
        console.log(this.fire.incident.detections[0]);
        console.log(this.fire.incident);
        //this.map.displaySites([this.fire.camera.twin], this.getIcon, null/*this.showView*/, null, true);
        //this.map.displayBearing(this.fire.camera.twin, this.fire.incident.cameraBearing, 32);
        //this.map.displayDetection(this.fire.camera.twin, this.fire.incident.detections[0].bearing, this.fire.incident.detections[0].width);
      });
      console.log(this.fire.incident);
      const siteUri = this.fire.incident.site.siteUri;
      const imageUri = this.fire.incident.imageFeedUri;
      if (imageUri != null){
        this.dataService.DataGetData({ 
          customerId: this.app.customerId, 
          request:{
            period: '-1h:1h', 
            type: 'media',
            timeZoneOffset: this.app.getTimeZoneOffset(null),
            forceEmbed: false,
            index: 0,
            publishedIdentifier: null,
            siteUri: null,
            timeSeries: {
              single:{
                variable: {
                  uri: imageUri,
                  transforms: null,   
                }       
              }   
            }
          }
        })
        
        //.DataGetData({uri: imageUri, transforms: null, period: 'latest', customerId: this.app.customerId, type:"media", timeZoneOffset: null})
        .subscribe(r => {
          this.latestImageUrl = r.values[0].valueStr;
        });
      }
      //this.liveWidget = {name:"Live",showTitle:false, realTime:false, period:'-1h:1h',refreshInterval:0,timeSeriesList:[{uri:'in-restapi-restapi-southsisters-288',forceEmbed:false,sourceType:'media'} as TimeSeriesDetail]} as IMultiSourceMultiValueWidget;
      //this.map.displaySites([this.fire.incident.site], this.getIcon, null, null);
      //todo: load the camera 
      
    }
  }


  getIcon(site: SiteTwin, pins: any[]){
    const icon = {icon: pins[site.siteType] ?? pins["blueSelected"]};
    return icon;
  }

  notAFire(incident: Incident, falsePositiveTypeId: number | null) {
    this.incident = incident;
    if (falsePositiveTypeId != null) {
      incident.falsePositiveTypeId = falsePositiveTypeId;
    }
    const status = this.list.find(f => f.statusId == 5);
    this.updateStatus(incident, status);
  }

  updateStatus(incident: Incident, status: StatusType) {
    incident.status = status;
    /*if (status.statusId == 8 && this.fire.incident.responsiblePartyId == null) {
      // request user to fill in who is responsible
      this.responsibleModal.show();
    }
    else*/ if (status.statusId == 5 && incident.falsePositiveTypeId == null) {
      // its not a fire - can the user categorise it
      this.falsePositiveModal.show();
    }
    else {
      this.fire.update(incident, () => {
        this.toasterService.success("Updated", "Incident");
      });
    }
  }
}